import React, { useState, useEffect } from "react";
import { ApiGet, ApiPost } from "../../../service/ApiService";
import { Container, Form, Button, Alert } from "react-bootstrap";

const ProductImportStock = () => {
    const [warehouses, setWarehouses] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState("");
    const [error, setError] = useState(null);
    const [uploadMessage, setUploadMessage] = useState("");

    // Fetch warehouses on component mount
    useEffect(() => {
        ApiGet(
            "/api/smartbill/warehouses",
            (response) => {
                setError(null);
                setWarehouses(response || []);
            },
            (error) => {
                setError(error.response?.data?.message || "Eroare la preluarea depozitelor.");
                setWarehouses([]);
            }
        );
    }, []);

    const handleWarehouseChange = (e) => {
        setSelectedWarehouse(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!selectedWarehouse) {
            setError("Selectați un depozit.");
            return;
        }

        ApiPost(
            "/api/smartbill/stock/import/"+selectedWarehouse,
            null,
            (response) => {
                setUploadMessage("Importul a fost adaugat in lista de taskuri.");
                setError(null);
            },
            (error) => {
                setError(
                    error.response?.data?.message || "A apărut o eroare în timpul importului stocului."
                );
                setUploadMessage("");
            }
        );
    };

    return (
        <Container fluid className="mt-5">
            <h1>Import Stoc Produse</h1>
            {error && <Alert variant="danger">{error}</Alert>}
            {uploadMessage && <Alert variant="success">{uploadMessage}</Alert>}

            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Selectează Depozit</Form.Label>
                    <Form.Control 
                        as="select" 
                        value={selectedWarehouse}
                        onChange={handleWarehouseChange}
                        style={{ fontSize: "1.2rem", padding: "0.75rem" }}
                    >
                        <option value="">-- Selectează un depozit --</option>
                        {warehouses.map((wh) => (
                            <option key={wh.id} value={wh.id} style={{ fontSize: "1.2rem" }}>
                                {wh.warehouseName} ({wh.warehouseType})
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>

                <Button variant="primary" type="submit">
                    Import Stoc
                </Button>
            </Form>
        </Container>
    );
};

export default ProductImportStock;